<template lang="pug">
validation-observer(ref='validation').container-cadastro
    .card-header Retificação de cadastro de arrecadação
    el-tabs#scroll.content(:value="menu" @tab-click="mudarTab")
      template(v-for="tab in tabs")
        el-tab-pane(:name="tab.name")
          span(slot="label")
            | {{tab.label}} &nbsp
            el-tooltip(effect='light', placement='bottom', v-if="tabPossuiErro(tab.label)")
              span(slot="content")
                p(v-for="erro in getErrosTab(tab.label)")
                  pre
                    | {{erro}}
              i.el-icon-warning.tooltip-icon

      despachos(
        v-if="historicoDespachos && historicoDespachos.length",
        :cadastroColetivo="cadastroColetivo",
        :despachos="historicoDespachos",
        :isRetificacao="true"
      )

      div.container-tab
        validation-observer(ref='observer' tag='form')
          keep-alive
            router-view(
              v-if="cadastroColetivo.id"
              :cadastroColetivo="cadastroColetivo",
              @onRemoveGeometria="onRemoveGeometria",
              @atualizarGeorreferenciamento="atualizarPecaTecnica"
            )

    app-radios-tramitacao(
      v-if="isUltimoPasso && radiosAcoes.length",
      :radios="radiosAcoes",
      :isDecisao="true",
      :radioInicial="radioInicial",
      @changeRadio="changeRadio"
    )

    app-buttons-cadastro(
      :isPrimeiroPasso="isPrimeiroPasso",
      :isUltimoPasso="isUltimoPasso",
      :showButtonSalvar="true",
      :showButtonProximo="!isUltimoPasso"
      @proximo="proximo",
      @salvar="salvarCadastro",
      @voltar="voltar",
      @cancelar="cancelar",
      @finalizar="finalizarCadastro"
    )
</template>

<script>
import AppLabel from '@/components/AppLabel'
import AppUploadArea from '@/components/AppUploadArea'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import rotas from '@/constants/rotas'
import { mapActions } from 'vuex'
import { cloneDeep, pickBy, identity } from 'lodash'
import Despachos from '@/screens/arrecadacao/components/Despachos'

const PECA_TECNICA_EMPTY = {
  gleba: null,
  interessado: null,
  documentos: [],
  jsonPlanilha: null,
  responsavel: null,
  tipoPlanilha: null,
  area: null,
  perimetro: null,
  geom: null,
  municipios: []
}

const PROCESSO_ARRECADACAO_EMPTY = {
  despachos: null
}

const CADASTRO_COLETIVO_EMPTY = {
  pecaTecnica: PECA_TECNICA_EMPTY,
  processoArrecadacao: PROCESSO_ARRECADACAO_EMPTY
}

const DESPACHO_EMPTY = {
  texto: '',
  documento: null,
  processoId: null,
  despachoId: null,
  acao: null
}

export default {
  mixins: [AppNotificacao],

  data () {
    return {
      cadastroColetivo: cloneDeep(CADASTRO_COLETIVO_EMPTY),
      radiosAcoes: [],
      acao: null,
      validExtensions: ['pdf'],
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      despacho: cloneDeep(DESPACHO_EMPTY),
      historicoDespachos: null,
      radioInicial: null
    }
  },

  components: {
    AppButtonsCadastro,
    Despachos,
    AppRadiosTramitacao,
    AppLabel,
    AppUploadArea
  },

  async created () {
    const idCadastroColetivo = this.$route.query.idCadastroColetivo
    if (idCadastroColetivo) {
      this.findByIdCadastroColetivo(idCadastroColetivo)
        .then(response => {
          const { id } = response.processoArrecadacao
          this.mergeCadastroColetivo(response)
          this.iniciarProcesso(id)
          this.setDespachos(response.processoArrecadacao.despachos, id)
        })
        .catch(e => {
          this.$router.push({
            name: 'gat/home'
          })
        })
    }
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex(tab => tab.name === this.$route.name)
    },

    tabs () {
      const cadastroColetivoId = this.cadastroColetivo.id
      return this.getTabs(cadastroColetivoId)
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isUltimoPasso () {
      return this.indexTabAtual === this.tabs.length - 1
    }
  },

  async beforeRouteUpdate (to, from, next) {
    this.validarCampos()
    next()
  },

  methods: {
    ...mapActions({
      salvarCadastroColetivo: 'cadastroColetivo/saveStep',
      findByIdCadastroColetivo: 'cadastroColetivo/findById',
      retificar: 'processoArrecadacao/tramitarComAcao',
      tarefa: 'processoArrecadacao/tarefa',
      salvarDespacho: 'despachos/save',
      iniciarAnalise: 'processoArrecadacao/iniciarAnalise',
      downloadDocumentos: 'documentoArrecadacao/download'
    }),

    async iniciarProcesso (id) {
      try {
        await this.iniciarAnalise({ processoId: id })
        this.setRadios(id)
      } catch (e) {
        this.$router.push({
          name: 'gat/home'
        })
      }
    },

    setDespachos (despachos, processoId) {
      const despacho = despachos.find(despacho => despacho.isUltimo)
      this.historicoDespachos = despachos.filter(despacho => !despacho.isUltimo)
      if (despacho) {
        this.setDespacho(despacho, processoId)
        this.changeRadio(despacho)
      } else {
        this.despacho = cloneDeep(DESPACHO_EMPTY)
        this.despacho.processoId = processoId
      }
    },

    setDespacho (despacho, processoId) {
      this.despacho = {
        texto: despacho.texto || '',
        documento: despacho.documento,
        processoId: processoId,
        despachoId: despacho.id,
        acao: despacho.acao
      }
    },

    async setRadios (idProcesso) {
      this.radios = await this.tarefa({ processo: idProcesso })
      this.radiosAcoes = this.radios.acoes
    },
    changeRadio (value) {
      this.radioInicial = value.acao
      this.acao = value.acao
      this.despacho.acao = value.acao
    },

    mergePecaTecnica (geo) {
      const idGeo = this.cadastroColetivo.pecaTecnica.id

      this.cadastroColetivo.pecaTecnica = geo
      this.cadastroColetivo.pecaTecnica.id = idGeo
    },

    onRemoveGeometria () {
      this.mergePecaTecnica(PECA_TECNICA_EMPTY)
    },

    atualizarPecaTecnica (geo) {
      this.mergePecaTecnica(geo)
    },

    mergeCadastroColetivo (cadastroColetivo) {
      this.cadastroColetivo = {
        ...cloneDeep(CADASTRO_COLETIVO_EMPTY),
        ...pickBy(cadastroColetivo, identity)
      }
    },

    async validarCampos () {
      return this.$refs.validation.validate()
    },

    proximo () {
      if (this.indexTabAtual !== this.tabs.length - 1) {
        this.navigate(this.indexTabAtual + 1)
        this.scrollToTop()
      }
    },

    async salvarCadastro () {
      this.validarCampos()
      const tabAtual = this.tabs[this.indexTabAtual]
      if (tabAtual.dadosRequest.url) {
        try {
          const response = await this.salvarCadastroColetivo(
            {
              ...tabAtual.dadosRequest,
              dados: {
                ...tabAtual.dadosRequest.dados,
                dadoPecaTecnica: {
                  ...tabAtual.dadosRequest.dados?.dadoPecaTecnica,
                  responsavel: {
                    ...tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel,
                    codigoCredenciamento: tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel?.codigoIncra
                  }
                }
              }
            }
          )

          const despacho = await this.salvarDespacho({
            dados: { ...this.despacho }
          })

          this.setDespacho(despacho, response.processoArrecadacao.id)

          this.mergeCadastroColetivo(response)

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.DADOS_SALVOS_SUCESSO
          )
        } catch (error) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
          throw error
        }
      }
    },

    voltar () {
      if (this.indexTabAtual !== 0) {
        this.confirmBox(
          'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
          this.$messages.TITULO_WARNING,
          () => {
            const index = this.indexTabAtual - 1

            this.$router.push({
              name: this.tabs[index].name,
              query: {
                idCadastroColetivo: this.cadastroColetivo.id
              }
            })
            this.scrollToTop()
          },
          () => {},
          'Sim',
          'Não'
        )
      }
    },

    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'gat/home'
          })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    async finalizarCadastro () {
      const isValido = await this.$refs.validation.validate()
      if (!isValido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VERIFICAR_CAMPOS
        )
        return
      }
      this.confirmBox(
        'Deseja confirmar esta ação?',
        this.$messages.TITULO_WARNING,
        async () => {
          try {
            const tabAtual = this.tabs[this.indexTabAtual]

            let response = await this.salvarCadastroColetivo(
              {
                ...tabAtual.dadosRequest,
                dados: {
                  ...tabAtual.dadosRequest.dados,
                  dadoPecaTecnica: {
                    ...tabAtual.dadosRequest.dados?.dadoPecaTecnica,
                    responsavel: {
                      ...tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel,
                      codigoCredenciamento: tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel?.codigoIncra
                    }
                  }
                }
              }
            )
            this.mergeCadastroColetivo(response)
            this.$nextTick(async () => {
              response = await this.validarCampos()
              if (response) {
                try {
                  response = await this.retificar({
                    ...this.despacho,
                    processoId: this.cadastroColetivo.processoArrecadacao.id
                  })

                  this.showNotificacao(
                    this.$messages.TIPO_SUCCESS,
                    this.$messages.TITULO_SUCCESS,
                    response
                  )

                  this.$router.push({
                    name: 'gat/home'
                  })

                  return
                } catch (error) {
                  let message = error.message

                  this.showNotificacao(
                    this.$messages.TIPO_ERROR,
                    this.$messages.TITULO_ERROR,
                    message
                  )

                  return
                }
              }
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO
              )
            })
          } catch (error) {
            let message = error.message

            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              message
            )
          }
        },
        () => {},
        'Confimar',
        'Cancelar'
      )
    },

    mudarTab (componente) {
      const indexTab = this.tabs.findIndex(
        tab => tab.name === componente._props.name
      )
      this.navigate(indexTab)
      this.scrollToTop()
    },

    scrollToTop () {
      document.getElementById('scroll').scrollIntoView({
        block: 'start'
      })
    },

    tabPossuiErro (label) {
      let temErro = false
      if (this.$refs.validation) {
        for (const key in this.$refs.validation.errors) {
          if (
            key.substring(0, key.indexOf('/')) === label &&
            this.$refs.validation.errors[key].length > 0
          ) {
            temErro = true
          }
        }
      }
      return temErro
    },

    getErrosTab (label) {
      let erros = []
      if (this.$refs.validation) {
        for (const key in this.$refs.validation.errors) {
          if (
            key.substring(0, key.indexOf('/')) === label &&
            this.$refs.validation.errors[key].length > 0
          ) {
            const campo = key.substring(key.indexOf('/') + 1, key.length)
            erros.push(`${campo}: ${this.$refs.validation.errors[key][0]}`)
          }
        }
      }
      return erros
    },

    removerDocumento () {
      let documento = cloneDeep(this.despacho.documento)

      if (documento.id) {
        documento.removed = true
      } else {
        documento = null
      }

      this.despacho.documento = documento
    },

    async navigate (indexTab) {
      try {
        await this.salvarCadastro()

        this.$router.push({
          name: this.tabs[indexTab].name,
          query: {
            idCadastroColetivo: this.cadastroColetivo.id
          }
        })
      } catch (error) {
        throw error
      }
    },
    getTabs (cadastroColetivoId) {
      return [
        {
          label: 'Peças Técnicas',
          name: 'retificacaoCadastro/pecaTecnica',
          dadosRequest: {
            url: rotas.ARRECADACAO.SALVAR_PECA_TECNICA(cadastroColetivoId),
            dados: this.cadastroColetivo.pecaTecnica
          }
        }
      ]
    },
    onSuccess (id, resumableFile, fileKey) {
      let documento = this.despacho.documento

      this.despacho.documento = {
        id: documento ? documento.id : null,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false
      }
    },
    async download (id) {
      const documento = this.despacho.documento

      const arrayBuffer = await this.downloadDocumentos({
        fileKey: documento.fileKey,
        id: documento.id
      })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    whitespace (field) {
      this.despacho[field] = this.despacho[field]?.trim()
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;

.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.content {
  flex: 1;
  padding-top: 10px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/components/retificacaoCadastro/RetificacaoCadastro.vue